<template>
  <div class="place">
    <main-content right-sidebar="true" :key="$route.fullPath">
      <video-player
        :source="source"
        ref="videoPlayer"
        @status="playerStatus"
      />
      <video-slider
        ref="videoSlider"
        :videos="videos"
        :status="status"
        @active-index="activeIndex"
        @play="playVideo"
        @pause="pauseVideo"
        @showImage="showImage"
        @stop="stopVideo"
      />
    </main-content>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MainContent from '@/components/MainContent'
import VideoPlayer from '@/components/VideoPlayer'
import VideoSlider from '@/components/VideoSlider'

export default {
  name: 'video-page',
  
  components: { MainContent, VideoPlayer, VideoSlider },

  data () {
    return {
      source: null,
      status: 'stopped'
    }
  },

  computed: {
    ...mapGetters([
      'activePage'
    ]),

    autoplay () {
      return this.activePage.autoplayVideos
    },

    type () {
      if (this.source) {
        const ext = this.source.split('.').pop()
  
        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
          return 'image'
        }
  
        if (['mov', 'mp4', 'webm'].includes(ext)) {
          return 'video'
        }
  
        return null
      }

      return null
    },

    videos () {
      return this.activePage.videos
    }
  },

  watch: {
    videos () {
      this.init()
    },

    status (newStatus) {
      if (this.autoplay && newStatus === 'stopped') {
        this.$refs.videoSlider.playNextSlide()
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      // set defaults
      this.source = null
      this.status = 'stopped'

      setTimeout(() => {
        this.source = this.videos[0].asset.path
        if (this.autoplay) {
          this.playVideo()
        } else {
          this.stopVideo()
        }
      }, 1000)
    },

    activeIndex (index) {
      this.source = this.videos[index].asset.path

      if (this.type === 'video') {
        this.playVideo()
      }
    },

    playVideo () {
      this.$refs.videoPlayer.play()
    },

    pauseVideo () {
      this.$refs.videoPlayer.pause()
    },

    stopVideo () {
      this.$refs.videoPlayer.stop()
    },

    showImage () {
      this.$refs.videoPlayer.showImage()
    },

    playerStatus (status) {
      this.status = status
    }
  }
}
</script>
<style lang="scss">

.place {
  height: 100%;
  left: 0;
  pointer-events: auto;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
